import { Component, Output, OnInit, OnDestroy } from '@angular/core';
import { FormGroupDirective, ControlContainer, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { UsedSgkc011aService } from '../../services/used-sgkc011a.service';
import { UsedSgkc012aService } from '../../services/used-sgkc012a.service';
import { UsedSgkc015aService } from '../../services/used-sgkc015a.service';
import { UsedSgkc027aService } from '../../services/used-sgkc027a.service';
import { UsedSgkc024aService } from '../../services/used-sgkc024a.service';
import { CodeConversionMstDto, Sgkc011aReqSlideadjustmentunitpriceSearchinfoDto, Sgkc011aRequest, Sgkc012aReqSlideadjustmentunitpriceShutokuinfoDto, Sgkc012aRequest, Sgkc015aReqAdjustmentunitfeeListShutokuinfoDto, Sgkc015aRequest, Sgkc024aRequest, Sgkc027aRequest, Sgkc027aResponse, Sgkc024aReqSlideadjustmentunitpriceListExtractionconditionDto, SlideadjustmentunitpriceListExtractionconditionDto, SlideadjustmentunitpriceLstInfoDto, Sgkc027aReqTankaApprvalauthShutokuinfoDto } from 'sg-api';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DisplayMode } from 'cbc-shared-lib';
import { SearchStat } from '../../../../../sg-kc-shared/constants/searchStat';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { TankaauthorityDivcd } from '../../../../../sg-kc-shared/constants/tankaauthorityDivcd';

/** 
 * スライド調整単価表検索画面
 * @exports
 * @class Sgkc031dComponent
 * @implements {OnInit,OnDestroy}
 */
@Component({
    selector: 'app-sgkc031d',
    templateUrl: './sgkc031d.component.html',
    styleUrl: './sgkc031d.component.scss',
    providers: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkc031dComponent implements OnInit, OnDestroy {

    /** 各必須項目の初期値 */
    readonly DEFAULT_SELECT_VALUE = " ";

    /** エラーメッセージリスト */
    @Output() errorMessageModelArray: Array<SgAriaMessage>;
    /** コード変換マスタのMap */
    @Output() codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;
    /** スライド調整単価表検索条件Form */
    slideTankaConditionForm: UntypedFormGroup;
    /** 表示フラグ */
    showResult: boolean = false;
    /** 購読を停止するためのSubject */
    private onDestroy$ = new Subject();
    /** スライド調整単価表検索結果 */
    searchResult: SlideadjustmentunitpriceLstInfoDto[];
    /** 単価表承認権限取得結果 */
    sgkc027aResponse: Sgkc027aResponse;
    /*コード変換マスタ結果 */
    codeConversionMstDto: Map<string, CodeConversionMstDto[]>;
    /** 画面モード */
    displayMode: string;
    /** 承認ステータス */
    apprvStatuscode: string;
    /** 選択情報 */
    selectedSearchResultRowInfo: SlideadjustmentunitpriceLstInfoDto[];
    /** 単価権限区分コード */
    tankaauthorityDivcd: string;

    /** 
     * コンストラクタ
     * @param {Router} router 
     * @param {UntypedFormBuilder} fb 
     * @param {UsedSgkc011aService} usedSgkc011aService 
     * @param {UsedSgkc012aService} usedSgkc012aService 
     * @param {UsedSgkc015aService} usedSgkc015aService 
     * @param {UsedSgkc024aService} usedSgkc024aService 
     * @param {UsedSgkc027aService} usedSgkc027aService 
     * @param {CodeConversionMstService} codeConversionMstService
     * @param {ActivatedRoute} route 
     * @memberof Sgkc031dComponent
     */
    constructor(private router: Router,
        private fb: UntypedFormBuilder,
        private usedSgkc011aService: UsedSgkc011aService,
        private usedSgkc012aService: UsedSgkc012aService,
        private usedSgkc015aService: UsedSgkc015aService,
        private usedSgkc024aService: UsedSgkc024aService,
        private usedSgkc027aService: UsedSgkc027aService,
        private codeConversionMstService: CodeConversionMstService,
        private route: ActivatedRoute,) {
        this.slideTankaConditionForm = this.fb.group({});
    }

    /** 初期処理
     * @memberof Sgkc031dComponent
     */
    ngOnInit(): void {

        // 画面モードを取得
        this.route.paramMap.subscribe(params => {

            this.showResult = false;
            this.displayMode = params.get('mode');
            // 単価権限区分コードを取得
            if (this.displayMode === DisplayMode.create) {
                this.tankaauthorityDivcd = TankaauthorityDivcd.create;
            } else if (this.displayMode === DisplayMode.read) {
                this.tankaauthorityDivcd = TankaauthorityDivcd.read;
            } else if (this.displayMode === DisplayMode.approve) {
                this.tankaauthorityDivcd = TankaauthorityDivcd.approve;
            } else if (this.displayMode === DisplayMode.delete) {
                this.tankaauthorityDivcd = TankaauthorityDivcd.create;
            }

            // 受信データの購読設定。
            // 検索結果に値が流れたときに、検索結果を表示するプレゼンテーショナルコンポーネントに渡している値を更新する。
            this.usedSgkc011aService.slideTankaInfoChanges
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(slideTanka => {
                    this.searchResult = slideTanka;
                });
            this.usedSgkc012aService.slideTankatableChanges
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(response => {
                    const row: SlideadjustmentunitpriceLstInfoDto = this.selectedSearchResultRowInfo[0];
                    // 単価表登録管理情報.承認ステータスコードを取得
                    this.apprvStatuscode = response.slideadjustmentunitpriceInfo.apprvStatuscode;
                    // 承認ステータスコードが承認済のとき
                    if (this.apprvStatuscode === SearchStat.SHONINZUMI) {
                        // 次の画面へ遷移
                        this.router.navigate(['/sgkc/sgkc032d', {
                            mode: this.displayMode,// 画面モードコード
                            backmode: this.displayMode, // 戻るボタン用画面モード
                            slideadjustmentunitpriceCode: row.slideadjustmentunitpriceCode,// スライド調整単価コード
                        }])
                    } else if (this.apprvStatuscode === SearchStat.mishonin) {// 未承認のとき
                        window.alert("未承認のスライド調整単価が存在します。");
                    }
                });
            this.usedSgkc027aService.slideTankatableAuthorityChanges
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(response => {
                    if (response) {
                        this.sgkc027aResponse = response;
                    }
                });

            // スライド調整単価承認権限取得API
            // 画面引継ぎ項目単価権限区分コードを取得しリクエストを作成
            const tankaApprvalauthShutokuinfo: Sgkc027aReqTankaApprvalauthShutokuinfoDto = {
                tankaauthorityDivcd: this.tankaauthorityDivcd
            }
            
            const sgkc027aRequest: Sgkc027aRequest = {
                tankaApprvalauthShutokuinfo: tankaApprvalauthShutokuinfo
            }
            // スライド調整単価承認権限取得APIを呼び出し
            this.usedSgkc027aService.getSlideTankatableAuthorityInf(sgkc027aRequest)
                .subscribe(response => {
                }, error => {
                });

            //コード変換マスタを呼び出し
            this.codeConversionMstService.getCodeConversionMst([
                "S900020",// 会社コード
                "S100020",// エネルギー種別
                "S100110",// ＬＰ販売形態
                "S100031",// 承認ステータス
            ])
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(data => {
                    this.codeConversionMstMap = data;
                });
        });
    }

    /** 
     * 購読を停止するための処理
     * @memberof Sgkc031dComponent
     */
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    /**
     * 検索ボタン押下処理
    * @remarks
    * スライド調整単価表検索条件をもとに、スライド調整単価表を検索する。
     * @memberof Sgkc031dComponent
     */
    onClickSearch(): void {
        this.selectedSearchResultRowInfo = [];
        this.showResult = false;
        // リクエストを作成
        let form = this.slideTankaConditionForm.getRawValue().slideTankaConditionInfo;

        const slideadjustmentunitpriceSearchinfo: Sgkc011aReqSlideadjustmentunitpriceSearchinfoDto = {
            companygroupcode: null,// 会社グループコード
            companycode: form.companycode,// 会社コード
            energyClscode: form.energyClscode,// エネルギー種別コード
            lpSalesformcode: form.lpSalesformcode === this.DEFAULT_SELECT_VALUE ? null : form.lpSalesformcode,// ＬＰ販売形態コード
            apprvAuthorityCode: form.apprvAuthorityCode,// 承認部門
            slideadjustmentunitpriceCode: null,// スライド単価調整コード
            applyYmStart: form.applyYmStart.replace('-', ''),// 適用年月（開始）
            applyYmEnd: form.applyYmEnd === '' || form.applyYmEnd === null ? null : form.applyYmEnd.replace('-', ''),// 適用年月（終了）
            apprvStatuscode: form.apprvStatuscode// ステータス  
        }
        const request: Sgkc011aRequest = {
            slideadjustmentunitpriceSearchinfo: slideadjustmentunitpriceSearchinfo
        };

        // サービス呼び出し
        this.usedSgkc011aService.searchSlideTankatable(request)
            .subscribe(response => {
                if (response) {
                    this.showResult = true;
                }
            }, error => {
            });
    }

    /** 
    * スライド調整単価一覧表出力ボタン押下処理
    * @remarks
    * 処理が成功した場合、レスポンスのスライド調整単価一覧表ファイルをダウンロードする。
    * 処理が失敗した場合、エラーメッセージを表示する。
    * @memberof Sgkc031dComponent
    */
    onClickSlideTankaOutput(): void {
        if (this.selectedSearchResultRowInfo.length > 0) {
            // リクエストを作成
            const extractionconditionList: SlideadjustmentunitpriceListExtractionconditionDto[] = this.selectedSearchResultRowInfo.map(dto => ({
                slideadjustmentunitpriceCode: dto.slideadjustmentunitpriceCode,
                applyYm: dto.applyYm,
                applyStartyearmonth: dto.applyStartyearmonth,
                applyStartDate: dto.applyStartDate
            }));
            const slideadjustmentunitpriceListExtractioncondition: Sgkc024aReqSlideadjustmentunitpriceListExtractionconditionDto = {
                slideadjustmentunitpriceListExtractionconditionlist: extractionconditionList,
            }
            const request: Sgkc024aRequest = {
                slideadjustmentunitpriceListExtractioncondition: slideadjustmentunitpriceListExtractioncondition,
            }
            // サービス呼び出し
            this.usedSgkc024aService.outputSlideTanka(request)
                .subscribe(response => {
                }, error => {
                });
        }
    }

    /** 
    * 調整単位料金一覧表出力ボタン押下処理
    * @remarks
    * 処理が成功した場合、レスポンスの調整単位料金一覧表ファイルをダウンロードする。
    * 処理が失敗した場合、エラーメッセージを表示する。
    * @memberof Sgkc031dComponent
    */
    onClickAdjustTankaOutput(): void {
        if (this.selectedSearchResultRowInfo.length > 0) {
            this.selectedSearchResultRowInfo.map(dto => {
                // リクエストを作成
                const adjustmentunitfeeListShutokuinfo: Sgkc015aReqAdjustmentunitfeeListShutokuinfoDto = {
                    slideadjustmentunitpriceCode: dto.slideadjustmentunitpriceCode,
                    applyYm: dto.applyYm,
                    applyStartyearmonth: dto.applyStartyearmonth,
                    applyStartDate: dto.applyStartDate
                }
                const request: Sgkc015aRequest = {
                    adjustmentunitfeeListShutokuinfo: adjustmentunitfeeListShutokuinfo
                }
                // サービス呼び出し
                this.usedSgkc015aService.outputAdjustTanka(request)
                    .subscribe(response => {
                    }, error => {
                    });
            })
        }
    }

    /** 
    * 追加ボタン押下処理
    * @remarks
    * 承認ステータスが”未承認"の場合、メッセージボックスを表示する。
    * 承認ステータスが”承認済”の場合、「スライド調整単価登録画面」に遷移する。
    * @memberof Sgkc031dComponent
    */
    onClickAdd(): void {
        const row: SlideadjustmentunitpriceLstInfoDto = this.selectedSearchResultRowInfo[0];
        // リクエストの作成
        const slideadjustmentunitpriceShutokuinfo: Sgkc012aReqSlideadjustmentunitpriceShutokuinfoDto = {
            slideadjustmentunitpriceCode: row.slideadjustmentunitpriceCode,
            applyStartyearmonth: null,
            applyStartDate: null
        };
        const request: Sgkc012aRequest = {
            slideadjustmentunitpriceShutokuinfo: slideadjustmentunitpriceShutokuinfo
        };

        this.usedSgkc012aService.getSlideTankatableDetails(request)
            .subscribe(response => {
            }, error => {
            });
    }

    /** 
    * 行をダブルクリック時の処理
    * @remarks
    * 「スライド調整単価検索結果」の任意の行をダブルクリック時、「スライド調整単価登録画面」に遷移する。
    * 画面間パラメータ：スライド調整単価コード、適用開始年月、適用開始日付
    * @param {SlideadjustmentunitpriceLstInfoDto} row - ダブルクリックされた行のデータ
    * @memberof Sgkc031dComponent
    */
    onDbClickRow(row: SlideadjustmentunitpriceLstInfoDto): void {
        //画面モードが登録のとき参照モードに、それ以外はそのまま設定
        const paramdisplayMode = this.displayMode === DisplayMode.create ? DisplayMode.read : this.displayMode;
        /** 単価表登録画面への遷移 */
        this.router.navigate(['/sgkc/sgkc032d', {
            slideadjustmentunitpriceCode: row.slideadjustmentunitpriceCode,// スライド調整単価コード
            applyStartyearmonth: row.applyStartyearmonth,// 適用開始年月
            applyStartDate: row.applyStartDate,// 適用開始日付
            backmode: this.displayMode, // 戻るボタン用画面モード
            mode: paramdisplayMode,// 画面モード
        }])
    }

    /** 
    * クリアボタン押下時の処理
    * @memberof Sgkc031dComponent
    */
    onClickClear() {
        this.slideTankaConditionForm.reset();
        this.showResult = false;
        this.selectedSearchResultRowInfo = [];
    }

    /** 
     * チェックボックス選択時の処理
     * @param {SlideadjustmentunitpriceLstInfoDto[]} event - 選択された行のデータ
     * @memberof Sgkc031dComponent
     */
    onSelected(event: SlideadjustmentunitpriceLstInfoDto[]): void {
        this.selectedSearchResultRowInfo = event;
    }
}
